import { useLingui } from '@lingui/react';
import { Group, Image, Text } from '@mantine/core';
export const OtherTabItem: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Group align="center" gap={4} wrap="nowrap">
      <Image src="/assets/tokens/other.svg" alt="icon" w={48} h={24} />
      <Text fz={{
      base: 10,
      sm: 12
    }} tt="uppercase" c={{
      base: 'var(--text-dark)',
      lg: 'inherit'
    }} fw={700}>
        {i18n._('Others')}
      </Text>
    </Group>;
};